export default {
    // api: "http://192.168.2.12:8097",
    // api: "http://192.168.2.17:8097",
    // 测试地址
    // api: "https://test.aiteyixia.cn",
    // 生产地址
    api: "https://proxy.aitefuwu.cn/"
}


// WEBPACK FOOTER //
// ./src/serve.js